import { useIntl } from "react-intl"
import { CrudProvider } from "../../../../services/loggedin/CrudContext"
import { ListComponent } from "../../../parts/crud/List"
import { ColumnType } from "../../../parts/crud/Types"

export const DataMartLogsList = () => {
  const intl = useIntl();
   const columns: Array<ColumnType> = [
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.STATISTICS_GENERATION_LOGS.PROCESS_NAME'}),
      key: 'processName',
      type: 'text',
      orderable: true,
    },
    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.STATISTICS_GENERATION_LOGS.LAST_RUN'}),
      key: 'lastRunTimestamp',
      type: 'datetime',
      orderable: true,
    },

    {
      title: intl.formatMessage({id: 'SYSTEM_SETTINGS.STATISTICS_GENERATION_LOGS.NEXT_RUN'}),
      key: 'nextRunTimestamp',
      type: 'custom',
      orderable: false, 
      render:(record:any) => {


        let date = new Date();
        let hour = parseInt(date.getHours()+"");  
      
        if(hour % 2 === 0){ 
          date.setHours(hour+2);
        }else{
          date.setHours(hour+1);
        }
        date.setMinutes(0);
        date.setSeconds(0);

        return (<>{ intl.formatDate(date) }{' '}{ intl.formatTime(date) }</>);
      }
    },
   ]
  
  return (
    <>
      <CrudProvider api='system-settings/datamart-logs'>
            <ListComponent
              columns={columns}
              actions={[]}
              newButton={false}
              defOrder='lastRunTimestamp'
              defOrderDir='desc'
            >
              
            </ListComponent>
      </CrudProvider>
    </>
  )
}